import {createTheme, CssBaseline, StyledEngineProvider, ThemeProvider} from "@mui/material";

console.log("ENV dump:", import.meta.env);
console.log("Backend URL:", import.meta.env.VITE_BACKEND_URL);

import React from 'react'
import ReactDOM from 'react-dom/client'
// Load Roboto weights you use
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

// if you use Redux:
import { Provider } from 'react-redux'
import {store} from './app/store'
import './api/axiosConfig';

// your root component:
import AppMui from './AppMui' // or './App', whatever you use

const theme = createTheme({
    typography: {
        // make it explicit so everything (including CssBaseline) uses it
        fontFamily: ['Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(','),
    },
});


ReactDOM.createRoot(document.getElementById("root")).render(
    <StyledEngineProvider injectFirst>
        <Provider store={store}>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <AppMui />
        </ThemeProvider>
        </Provider>
    </StyledEngineProvider>
);

//
// ReactDOM.createRoot(document.getElementById('root')).render(
//     <React.StrictMode>
//         <Provider store={store}>
//             <AppMui />
//         </Provider>
//     </React.StrictMode>
// )